module.exports = __webpack_public_path__ + "static/img/app-products2@2x.72c610c1.png";